import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import { fetchBestServices, fetchServicesCount } from '../Api/v1/service/Api';
import UserNavigation from '../Components/v1/NavBar/Navigaton';
import Footer from '../Components/Footer/Footer';

import HomeHero from '../Components/v1/Homev2/HomeHero';
import HomeFeaturedProducts from '../Components/v1/Homev2/HomeFeaturedProducts';
import HomeClientStrip from '../Components/v1/Homev2/HomeClientStrip';
import HomeAboutIntro from '../Components/v1/Homev2/HomeAboutIntro';
import HomeStats from '../Components/v1/Homev2/HomeStats';
import HomeServices from '../Components/v1/Homev2/HomeServices';
import HomeCommand from '../Components/v1/Homev2/HomeCommand';
import HomeTopServices from '../Components/v1/Homev2/HomeTopServices';
import HomeProducts from '../Components/v1/Homev2/HomeProducts';
import HomeConsult from '../Components/v1/Homev2/HomeConsult';
import HomeContact from '../Components/v1/Homev2/HomeContact';
import HomeFloatingContact from '../Components/v1/Homev2/HomeFloatingContact';
import Newsletter from '../Components/v1/Home/Newletter';
import CustomerLogo from '../Components/v1/Services/CustomerLogo';

export default function NewHome() {
  const navigate = useNavigate();
  const [servicesCount, setServicesCount] = useState({});
  const [bestServices, setBestServices] = useState([]);

  useEffect(() => {
    const getBestServices = async () => {
      let data = await fetchBestServices();
      if (data && data.statusCode === 200) setBestServices(data?.data);
      else setBestServices([]);
    };
    const getServicesCount = async () => {
      let data = await fetchServicesCount();
      if (data && data.statusCode === 200) setServicesCount(data?.data);
      else setServicesCount({});
    };
    getBestServices();
    getServicesCount();

    // Scroll-reveal observer
    const revealItems = document.querySelectorAll(
      '.dalmaf-home .intro, .dalmaf-home .stats div, .dalmaf-home .service-card, .dalmaf-home .command, .dalmaf-home .compact-grid article, .dalmaf-home .product-card, .dalmaf-home .consult, .dalmaf-home .contact'
    );
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      document.body.classList.add('motion-ready');
      revealItems.forEach(item => item.classList.add('reveal'));
      const observer = new IntersectionObserver(
        entries => entries.forEach(e => {
          if (e.isIntersecting) { e.target.classList.add('is-visible'); observer.unobserve(e.target); }
        }),
        { threshold: 0.16 }
      );
      revealItems.forEach(item => observer.observe(item));
      return () => revealItems.forEach(item => observer.unobserve(item));
    } else {
      revealItems.forEach(item => item.classList.add('is-visible'));
    }
  }, []);

  const goTo = path => e => { e.preventDefault(); navigate(path); };

  const goToService = data => e => {
    e.preventDefault();
    navigate(`/services/${data.mainServiceName?.toLowerCase()}/${data.slug || data.title?.toLowerCase().replace(/\s+/g, '-')}`);
  };

  const legalCount = servicesCount.legal || 238;
  const auditCount = servicesCount.audit || 95;

  const serviceCards = [
    { title: 'Legal Service', filter: 'Legal', count: servicesCount?.legal || 0 },
    { title: 'Audit Service', filter: 'Audit', count: servicesCount?.audit || 0 },
    { title: 'HR Service',    filter: 'HR ', count: servicesCount?.man_power || 0 },
  ];

  return (
    <>
      <Helmet>
        <title>DALMAF | Audit, Legal, HR &amp; Investment Solutions</title>
        <meta name="description" content="DALMAF provides audit, legal, HR, compliance, advisory and investment solutions from Chennai." />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap" rel="stylesheet" />
      </Helmet>

      <div className="dalmaf-home">
        <UserNavigation newHome={true} />

        <main>
          <HomeHero legalCount={legalCount} auditCount={auditCount} />
          <HomeFeaturedProducts />
          <HomeClientStrip serviceCards={serviceCards} />
          <CustomerLogo/>
          <HomeAboutIntro />
          <HomeStats />
          <HomeServices bestServices={bestServices.slice(0,3)} onGoTo={goTo} onServiceClick={goToService} />
          <HomeCommand />
          <HomeTopServices bestServices={bestServices} onServiceClick={goToService} />
          <HomeProducts />
          <HomeConsult onGoTo={goTo} />
          <HomeContact />
          <Newsletter/>
        </main>

        <HomeFloatingContact />
      </div>

      <Footer />
    </>
  );
}
